import React from "react";
import { CompletedReviewsFilterSubHeader } from "../../layouts/ClientReviewManagementLayout";
import CompletedReviewsSummary from "../../features/completedreviewssummary";
import { FilterProvider } from "../../hooks/FilterContext";
import { CompletedReviewsDefaultFilters } from "../../hooks/FilterContext";

const CompletedReviewsSummaryPage = () => 
    <React.Fragment>
        <FilterProvider defaultFilters={CompletedReviewsDefaultFilters} filterStore="completed-reviews">
            <CompletedReviewsFilterSubHeader />
            <section className="px-4 my-3 h-100">
                <CompletedReviewsSummary />
            </section>
        </FilterProvider>
    </React.Fragment>


export default CompletedReviewsSummaryPage;